import { render, staticRenderFns } from "./fields.vue?vue&type=template&id=4e95db95&scoped=true&"
import script from "./fields.vue?vue&type=script&lang=js&"
export * from "./fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e95db95",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e95db95')) {
      api.createRecord('4e95db95', component.options)
    } else {
      api.reload('4e95db95', component.options)
    }
    module.hot.accept("./fields.vue?vue&type=template&id=4e95db95&scoped=true&", function () {
      api.rerender('4e95db95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/drag/fields.vue"
export default component.exports